module.exports = fox._r("images/settings-hover.png", __webpack_public_path__ + "images/settings-hover.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/settings-hover.png
// module id = 1106
// module chunks = 4